import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';


class Headers extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div className="navbarbar">
        <Navbar color="dark" dark expand="md">
        <NavbarBrand href="#/">Home</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="http://www.ukvac.com/forum">Forums</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="http://www.ukvac.com/forum/high-scores-index-start-here_topic364442.html">Scores</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#/news">News</NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  Archives
                </DropdownToggle>
                  <DropdownMenu>
                  <DropdownItem href="#/archives">Meets</DropdownItem>  
                  <DropdownItem href="http://ukvac.com/members/gallery/index.htm">Mugshots</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    href="#/"> Home
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  Technical
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem href="#/technical">Fix Logs</DropdownItem>  
                  <DropdownItem href="#/techlinks">Tech Links</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    href="#/"> Home
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink href="http://www.ukvac.com/forum/login_user.asp">Login</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://www.paypal.com/donate/?token=Iv_O5o5IrEcJlX-GvhiIEl-UqKbGXbhbpxHuAdNJlllFF2cafeUBXmaFFiKh5FqHX6VMjm&country.x=GB&locale.x=GB
">Donate</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>

      </div>
    );
  }
}

export default Headers;


// WEBPACK FOOTER //
// ./src/Header.js